import { InvalidSearch } from '@utils/errors';
import { parseSearch, stringifySearch } from '@utils/types';
import { isLeft } from 'fp-ts/lib/Either';
import * as t from 'io-ts';
import { isUndefined, omitBy } from 'lodash-es';
import { useHistory, useLocation } from 'react-router-dom';

export const useSearch = <T>(type: t.Type<T>) => {
  const history = useHistory();
  const location = useLocation();
  type Query = { [key: string]: string | string[] | number | undefined };
  const query = parseSearch(location.search) as Query;

  if (typeof query.page === 'string') {
    query.page = parseInt(query.page, 10);
  }

  const e = type.decode(query);

  if (isLeft(e)) {
    throw new InvalidSearch(`Invalid search: ${JSON.stringify(query)}`);
  }

  const sanitize = (p: any) => omitBy(p, (value) => isUndefined(value));

  return {
    search: e.right,
    updateSearch: (p: Partial<T>) => {
      const sanitized = sanitize({ ...e.right, ...p });
      history.push(`${location.pathname}?${stringifySearch(sanitized)}`);
    },
    setSearch: (p: T) => {
      const sanitized = sanitize(p);
      history.push(`${location.pathname}?${stringifySearch(sanitized)}`);
    },
    clearSearch: () => history.push(location.pathname),
  };
};
